<template>
  <v-container>
    <v-row dense>
      <PageTitle :title="label('title')"/>
    </v-row>
    <v-row>
      <div class="d-flex flex-column" style="width: 100%">
        <div class="d-flex flex-row justify-end">
          <div class="mr-4" style="width: 360px">
            <FileSelectField
                v-model="image"
                :name="label('image')"
                image
                :max-size="10 * 1024 * 1024"
                :hint="label('imageSizeHint')"
                @input="onInputImage"
            />
          </div>
          <Dialog :open="image != null" @close="image = null">
            <ImageEditor
                ref="editor"
                :src="image"
                :image-width="320 * 4"
                :image-height="180 * 4"
            />
            <template #actions>
              <ActionButton
                  :disabled="image == null"
                  @click="onUpload"
              >
                {{label("upload")}}
              </ActionButton>
            </template>
          </Dialog>
        </div>
        <v-divider class="my-4"/>
        <div class="d-flex flex-row flex-wrap">
          <v-img
              v-for="image in images"
              :key="image.id"
              :src="image.url"
              class="ma-2 image"
              max-width="300px"
              min-width="300px"
              max-height="169px"
          >
            <v-chip
                v-if="image.isUsed"
                color="primary"
                class="usedIcon"
            >
              {{label("used")}}
            </v-chip>
            <v-icon
                v-else
                class="deleteIcon pa-1"
                @click="onSelectDeleteImage(image)"
            >
              mdi-delete
            </v-icon>
          </v-img>
          <ImageDeleteConfirmDialog :open="selectDeleteImage !== null" :image="selectDeleteImage" @close="onCloseDeleteConfirmDialog" @delete="onDelete"/>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import PageTitle from "@/components/atoms/PageTitle";
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";
import ActionButton from "@/components/molecules/ActionButton";
import FileSelectField from "@/components/atoms/FileSelectField";
import ApiMixin from "@/ApiMixin";
import ImageDeleteConfirmDialog from "@/components/organisms/ImageDeleteConfirmDialog";
import Dialog from "../../atoms/Dialog";
import ImageEditor from "../../atoms/ImageEditor";
export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "ClientImagesPage",
  components: {ImageEditor, Dialog, ImageDeleteConfirmDialog, FileSelectField, ActionButton, PageTitle},
  data () {
    return {
      image: null,
      selectDeleteImage: null
    }
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("client", ["images"])
  },
  methods: {
    onInputImage(value) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.image = e.target.result
      }
      reader.readAsDataURL(value)
    },
    onUpload() {
      const editor = this.$refs.editor
      const image = editor.getImage()
      if (image != null) {
        const file = this.convertToFile(image)
        this.uploadImage(file).then(() => {
          this.image = null;
        })
      }
    },
    onSelectDeleteImage(image) {
      this.selectDeleteImage = image;
    },
    onCloseDeleteConfirmDialog() {
      this.selectDeleteImage = null;
    },
    onDelete(image, guard) {
      guard((release) => {
        this.deleteImage(image.id).then(() => {
          this.selectDeleteImage = null;
        }).finally(release);
      }, false)
    },
    convertToFile(data) {
      const blob = atob(data.replace(/^.*,/, ''))
      const buffer = new Uint8Array(blob.length)
      for (let index = 0; index < blob.length; index++) {
        buffer[index] = blob.charCodeAt(index)
      }
      return new File([buffer.buffer], 'user_image', { type: 'image/png' })
    },
  },
  watch: {
    "user.id": {
      handler: function(value) {
        if (value) {
          this.loadImages();
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="sass">
.image
  position: relative

  .usedIcon
    position: absolute
    right: 8px
    top: 8px
    font-size: 12px

  .deleteIcon
    position: absolute
    right: 8px
    top: 8px
    background-color: white
    border-radius: 50%
    font-size: 24px

</style>
